import React from 'react';
import ReactDOM from 'react-dom/client';
/* Imported and started before `App`, so the global error hooks and the
   console-logger's error sink are installed before any module that could
   throw during startup is evaluated. Import order is load order. */
import { initLogging } from '@logging';
import App from './App';

initLogging();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/* DevTools easter egg — a warm hello for the curious folks who open the
   console and an invitation to share what they think. Runs once at app
   boot, dev + prod. ASCII house renders in monospace so it stays aligned;
   the rest of the message is system-ui. Brand colors:
     - Dark coral  (#C65A5A) — accent.coral.exxxtraDark — for highlights
     - Dark seafoam(#2A675C) — brand.exxxtraDark         — for the link */
console.log(
  '%c\n       /\\\n      /  \\\n     /    \\\n    /______\\\n    |  []  |\n    |  ||  |\n    |__||__|\n\n' +
  '%cHello There!\n' +
  '%cLat Long Labs behind The Home CEO has a very small team, ie 1.\n' +
  'The agents and I are always looking for ways to make this better, and I\'d love\n' +
  'to hear what you think. Grab 15 minutes with me (June) for a virtual chat:\n' +
  '%chttps://calendar.app.google/Ma14YDYXQqmDwBSDA \n\n' +
  '%cHappy Coding!\n',
  'font: 14px ui-monospace, "SF Mono", Menlo, monospace; color: #C65A5A; line-height: 1.2;',
  'font: 600 18px system-ui, sans-serif; color: #C65A5A;',
  'font: 400 13px system-ui, sans-serif; color: #475569; line-height: 1.7;',
  'font: 600 13px system-ui, sans-serif; color: #2A675C;',
  'font: 600 18px system-ui, sans-serif; color: #C65A5A;',
);
